export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="12" fill="#0C1210" stroke="rgba(0,230,118,0.35)" />
    <path d="M16 12h8v16l14-16h10L32 30l17 22H38L24 34v18h-8z" fill="#F3F4F6" />
    <path d="M40 12h8v8z" fill="#00E676" />
    <rect x="16" y="54" width="32" height="3" fill="#00E676" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <button onClick={onClick} data-testid="brand-logo" className="flex items-center gap-3 group">
    <LogoMark className="h-9 w-9 transition-transform duration-500 group-hover:rotate-[-8deg]" />
    <span className="font-display text-[15px] font-extrabold tracking-[0.18em] text-white">
      KORANI<span className="text-[#00E676]"> GROUP</span>
    </span>
  </button>
);
